<template>
  <div class="container">
    <div class="partner-wrap style2 pb-100">
      <div class="row gx-5 align-items-center">
        <div class="col-xl-5 col-lg-6">
          <div class="partner-content">
            <div class="content-title style1">
              <span>Our Partner</span>
              <h2>Our Trusted Partners Who Trust About Us</h2>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                standard dummy text ever since the 1500.
              </p>
            </div>
          </div>
        </div>

        <div class="col-xl-7 col-lg-6">
          <div class="partner-item-wrap">
            <div
              class="partner-item"
              v-for="partner in partners"
              :key="partner.id"
            >
              <img :src="partner.image" alt="Image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "OurPartner",
  data: () => ({
    partners: [
      {
        id: 1,
        image: require("../../assets/images/partner/partner-1.png"),
      },
      {
        id: 2,
        image: require("../../assets/images/partner/partner-2.png"),
      },
      {
        id: 3,
        image: require("../../assets/images/partner/partner-3.png"),
      },
      {
        id: 4,
        image: require("../../assets/images/partner/partner-4.png"),
      },
      {
        id: 5,
        image: require("../../assets/images/partner/partner-5.png"),
      },
      {
        id: 6,
        image: require("../../assets/images/partner/partner-6.png"),
      },
    ],
  }),
});
</script>